import {
  alenzaAlertRuled, alenzaDashboard, alenzaInfoRuled, alenzaUsers, MenuItemUnion, Sidebar
} from "@avlino-inc/alenza-react";
import { faCrown, faFileAlt } from "@fortawesome/pro-light-svg-icons";
import { faChartNetwork } from "@fortawesome/pro-light-svg-icons/faChartNetwork";
import { faCog } from "@fortawesome/pro-light-svg-icons/faCog";
import { faCube } from "@fortawesome/pro-light-svg-icons/faCube";
import { faFlagAlt } from "@fortawesome/pro-light-svg-icons/faFlagAlt";
import { faGamepadAlt } from "@fortawesome/pro-light-svg-icons/faGamepadAlt";
import { faKey } from "@fortawesome/pro-light-svg-icons/faKey";
import { faLink } from "@fortawesome/pro-light-svg-icons/faLink";
import { faQuestionCircle } from "@fortawesome/pro-light-svg-icons/faQuestionCircle";
import { faShip } from "@fortawesome/pro-light-svg-icons/faShip";
import { getTheme } from "lib/theme";
import log from "loglevel";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import * as r from "routes";

const DashboardSidebar = ({ isAdmin, isAvlino }: { isAdmin: boolean; isAvlino: boolean }) => {
  const location = useLocation();
  const history = useHistory();

  const [theme, setTheme] = useState<string | undefined>();

  useEffect(() => {
    log.info("Sidebar useEffect()...");
    setTheme(getTheme());
  }, []);

  const menuItems: MenuItemUnion[] = useMemo(() => {
    const isAiCon = theme?.toLowerCase() === "aicon";

    let dashboardItems: any = [
      {
        key: "access-control",
        label: "Access Control",
        url: r.DASHBOARD_ACCESS_CONTROL,
        icon: alenzaUsers,
      },
    ];

    let adminDashboardItems: any = [
      {
        key: "configuration",
        label: "Configuration",
        url: r.DASHBOARD_CONFIGURATION,
        icon: faKey,
        show: isAdmin,
      },
      {
        key: "permissions",
        label: "Permissions",
        url: r.DASHBOARD_ROLES_PERMISSIONS,
        icon: faFlagAlt,
        show: isAdmin,
      },
    ];

    // Add contents to sidebar
    /*
      {
        key: "back-to-aicon",
        label: "Back to AiCon",
        url: r.AICON_DUMMY_ROUTE,
        icon: faChevronLeft,
        isExternal: true,
        show: isAiCon,
      },
      */
    const sidebarContents = [
      {
        key: "general-dashboard",
        label: "Dashboard",
        url: r.DASHBOARD_MAIN,
        icon: alenzaDashboard,
        items: dashboardItems,
      },
      {
        key: "admin-dashboard",
        label: "Admin Dashboard",
        url: r.DASHBOARD_ADMIN,
        icon: alenzaDashboard,
        items: adminDashboardItems,
        show: isAdmin && isAvlino,
      },
      {
        key: "yard",
        label: "Back to AiCON",
        // TODO: Make this an enviromnent variable? To support multiple servers in the future
        // BUG: This somehow needs the last slash when not on a default port, no idea why???
        url: `${window.location.origin}${r.AICON_DUMMY_ROUTE}`,
        icon: faShip,
        isExternal: true,
        show: isAiCon,
      },
      {
        key: "settings",
        label: "Settings",
        url: r.SETTINGS,
        icon: faCog,
      },
      {
        key: "about",
        label: "About",
        url: r.ABOUT,
        icon: alenzaInfoRuled,
      },
      {
        key: "help",
        label: "Help",
        url: r.DOCUMENTATION,
        icon: faQuestionCircle,
      },
      {
        key: "is_admin",
        label: "Logged in as Admin",
        icon: faCrown,
        show: isAdmin,
      },
    ];

    return sidebarContents;
  }, [isAdmin, theme]);

  const handleClickItem = useCallback(
    (url, item) => {
      if (item.isExternal) {
        window.location.href = url;
      } else {
        history.push(url);
      }
    },
    [history]
  );

  return (
    <>
      <Sidebar disableScrolling>
        <Sidebar.Menu
          currentUrl={location.pathname}
          onClickItem={handleClickItem}
          items={menuItems}
          // NOTE: Add baseUrl once we switch repo to not live at server root
          // baseUrl={'PUBLIC_URL_GOES_HERE'}
        />
      </Sidebar>
    </>
  );
};

export default DashboardSidebar;
